/* eslint-disable camelcase */
window.merchantos.formats = {
  valueToString(value, type) {
    switch (type) {
      case 'money':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | Date' is not assignable... Remove this comment to see the full error message
        window.formatMoney(value);
      // eslint-disable-next-line no-fallthrough
      case 'datetime':
        if (value instanceof Date) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
          return value.format('m/d/Y h:i a');
        }
        // see if it's really a "date time"
        if (value.indexOf(' ') > -1) {
          const date_and_time = value.split(' ');
          const date = date_and_time[0].split('-');
          const time = date_and_time[1].split(':');
          return new Date(
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
            new Date(date[0], date[1] - 1, date[2], time[0], time[1], time[2])
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
          ).format('m/d/Y h:i a');
        }
      // otherwise it's just a date
      // eslint-disable-next-line no-fallthrough
      case 'date':
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
        return new Date(value).format('m/d/Y');
      default:
        return value;
    }
  },
};
